import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssetChromeIconOl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 20C0 13.4729 0 10.2094 1.1453 7.66463C2.44896 4.76803 4.76803 2.44896 7.66463 1.1453C10.2094 0 13.4729 0 20 0C26.5271 0 29.7906 0 32.3354 1.1453C35.232 2.44896 37.551 4.76803 38.8547 7.66463C40 10.2094 40 13.4729 40 20C40 26.5271 40 29.7906 38.8547 32.3354C37.551 35.232 35.232 37.551 32.3354 38.8547C29.7906 40 26.5271 40 20 40C13.4729 40 10.2094 40 7.66463 38.8547C4.76803 37.551 2.44896 35.232 1.1453 32.3354C0 29.7906 0 26.5271 0 20Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.4268 38.6601C14.3225 38.7992 16.7188 38.8 20 38.8C23.2812 38.8 25.6775 38.7992 27.5732 38.6601C29.457 38.5217 30.7518 38.2515 31.8429 37.7604C34.4721 36.5771 36.5771 34.4721 37.7604 31.8429C38.2515 30.7518 38.5217 29.457 38.6601 27.5732C38.7992 25.6775 38.8 23.2812 38.8 20C38.8 16.7188 38.7992 14.3225 38.6601 12.4268C38.5217 10.543 38.2515 9.2482 37.7604 8.15713C36.5771 5.5279 34.4721 3.4229 31.8429 2.23958C30.7518 1.74853 29.457 1.47825 27.5732 1.33994C25.6775 1.20075 23.2812 1.2 20 1.2C16.7188 1.2 14.3225 1.20075 12.4268 1.33994C10.543 1.47825 9.2482 1.74853 8.15713 2.23958C5.5279 3.4229 3.4229 5.5279 2.23958 8.15713C1.74853 9.2482 1.47825 10.543 1.33994 12.4268C1.20075 14.3225 1.2 16.7188 1.2 20C1.2 23.2812 1.20075 25.6775 1.33994 27.5732C1.47825 29.457 1.74853 30.7518 2.23958 31.8429C3.4229 34.4721 5.5279 36.5771 8.15713 37.7604C9.2482 38.2515 10.543 38.5217 12.4268 38.6601ZM1.1453 7.66463C0 10.2094 0 13.4729 0 20C0 26.5271 0 29.7906 1.1453 32.3354C2.44896 35.232 4.76803 37.551 7.66463 38.8547C10.2094 40 13.4729 40 20 40C26.5271 40 29.7906 40 32.3354 38.8547C35.232 37.551 37.551 35.232 38.8547 32.3354C40 29.7906 40 26.5271 40 20C40 13.4729 40 10.2094 38.8547 7.66463C37.551 4.76803 35.232 2.44896 32.3354 1.1453C29.7906 0 26.5271 0 20 0C13.4729 0 10.2094 0 7.66463 1.1453C4.76803 2.44896 2.44896 4.76803 1.1453 7.66463Z",
			fill: "#E7E8E8"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_6199_8810",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 6,
			y: 6,
			width: 28,
			height: 28,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_6199_8810)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M8.22852 6V23.1818H14.4967L20.0012 13.6364H34.0012V6H8.22852Z",
					fill: "#DB4437"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.22852 6V23.1818H14.4967L20.0012 13.6364H34.0012V6H8.22852Z",
					fill: "url(#paint0_linear_6199_8810)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6 34H19.3318L25.5364 27.7955V23.1818H14.4636L6 8.625V34Z",
					fill: "#0F9D58"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6 34H19.3318L25.5364 27.7955V23.1818H14.4636L6 8.625V34Z",
					fill: "url(#paint1_linear_6199_8810)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.9996 13.6367L25.5042 23.1822L19.3633 34.0004H33.9996V13.6367H19.9996Z",
					fill: "#FFCD40"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.9996 13.6367L25.5042 23.1822L19.3633 34.0004H33.9996V13.6367H19.9996Z",
					fill: "url(#paint2_linear_6199_8810)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.6379 23.1346L8.22656 12.4277L14.4311 23.2141L14.6379 23.1346Z",
					fill: "#3E2723",
					fillOpacity: .1
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.3778 23.3879L25.2505 23.3242L19.3164 33.9833L25.4096 23.3242L25.3778 23.3879Z",
					fill: "#263238",
					fillOpacity: .1
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20 13.6367V16.9776L32.4727 13.6367H20Z",
					fill: "url(#paint3_radial_6199_8810)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.22656 12.4434L17.3266 21.5434L14.4947 23.182L8.22656 12.4434Z",
					fill: "url(#paint4_radial_6199_8810)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.332 33.9998L22.6729 21.543L25.5048 23.1816L19.332 33.9998Z",
					fill: "url(#paint5_radial_6199_8810)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.0004 26.364C23.5149 26.364 26.364 23.5149 26.364 20.0004C26.364 16.4858 23.5149 13.6367 20.0004 13.6367C16.4858 13.6367 13.6367 16.4858 13.6367 20.0004C13.6367 23.5149 16.4858 26.364 20.0004 26.364Z",
					fill: "#F1F1F1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.0011 25.092C22.8127 25.092 25.092 22.8127 25.092 20.0011C25.092 17.1894 22.8127 14.9102 20.0011 14.9102C17.1894 14.9102 14.9102 17.1894 14.9102 20.0011C14.9102 22.8127 17.1894 25.092 20.0011 25.092Z",
					fill: "#4285F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34Z",
					fill: "url(#paint6_radial_6199_8810)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.5045 23.1829C24.9452 24.1472 24.1422 24.9477 23.1762 25.5041C22.2101 26.0605 21.1148 26.3534 20 26.3534C18.8852 26.3534 17.7899 26.0605 16.8238 25.5041C15.8578 24.9477 15.0549 24.1472 14.4955 23.1829L6 8.78516L14.4955 23.342C15.0549 24.3063 15.8578 25.1068 16.8238 25.6632C17.7899 26.2196 18.8852 26.5125 20 26.5125C21.1148 26.5125 22.2101 26.2196 23.1762 25.6632C24.1422 25.1068 24.9452 24.3063 25.5045 23.342V23.1829Z",
					fill: "white",
					fillOpacity: .1
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.1591 13.6367H20.0795C21.7673 13.6367 23.3859 14.3072 24.5793 15.5006C25.7727 16.694 26.4432 18.3126 26.4432 20.0004C26.4432 21.6881 25.7727 23.3067 24.5793 24.5001C23.3859 25.6935 21.7673 26.364 20.0795 26.364H20.1591C23.6591 26.364 26.5227 23.5004 26.5227 20.0004C26.5227 16.5004 23.6591 13.6367 20.1591 13.6367ZM20 33.8413C23.6993 33.8413 27.2482 32.3773 29.8715 29.7689C32.4947 27.1606 33.979 23.62 34 19.9208V20.0004C34 23.7134 32.525 27.2743 29.8995 29.8999C27.274 32.5254 23.713 34.0004 20 34.0004C16.287 34.0004 12.726 32.5254 10.1005 29.8999C7.475 27.2743 6 23.7134 6 20.0004V19.9208C6.02102 23.62 7.50529 27.1606 10.1285 29.7689C12.7518 32.3773 16.3007 33.8413 20 33.8413Z",
					fill: "#3E2723",
					fillOpacity: .1
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.5682 23.3886C26.0125 22.6263 26.2904 21.7785 26.3836 20.9011C26.4768 20.0237 26.3833 19.1364 26.1091 18.2977C26.3564 19.1087 26.4305 19.9626 26.3263 20.8041C26.2221 21.6455 25.9422 22.4556 25.5045 23.1818L19.5227 34L25.6 23.4205L25.5682 23.3886ZM20 6.15909C23.6993 6.15903 27.2482 7.6231 29.8715 10.2314C32.4947 12.8398 33.979 16.3803 34 20.0795V20C34 16.287 32.525 12.726 29.8995 10.1005C27.274 7.475 23.713 6 20 6C16.287 6 12.726 7.475 10.1005 10.1005C7.475 12.726 6 16.287 6 20V20.0795C6.02102 16.3803 7.50529 12.8398 10.1285 10.2314C12.7518 7.6231 16.3007 6.15903 20 6.15909Z",
					fill: "white",
					fillOpacity: .2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.0004 13.4766C16.5004 13.4766 13.6367 16.3402 13.6367 19.8402V19.9993C13.6367 16.4993 16.5004 13.6357 20.0004 13.6357H34.0004V13.4766H20.0004Z",
					fill: "#3E2723",
					fillOpacity: .2
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_6199_8810",
				x1: 9.38988,
				y1: 16.8182,
				x2: 17.7422,
				y2: 11.95,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#A52714",
					stopOpacity: .6
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .7,
					stopColor: "#A52714",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_6199_8810",
				x1: 22.3705,
				y1: 31.0568,
				x2: 13.0795,
				y2: 25.6159,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#055524",
					stopOpacity: .4
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .3,
					stopColor: "#055524",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_6199_8810",
				x1: 24.2792,
				y1: 12.8094,
				x2: 26.6178,
				y2: 23.039,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#EA6100",
					stopOpacity: .3
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .7,
					stopColor: "#EA6100",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint3_radial_6199_8810",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(19.3955 13.6367) scale(13.3795 13.3795)",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#3E2723",
					stopOpacity: .2
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#3E2723",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint4_radial_6199_8810",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(8.21065 12.4434) scale(12.4091 12.4091)",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#3E2723",
					stopOpacity: .2
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#3E2723",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint5_radial_6199_8810",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(19.9684 20.0157) scale(13.9841)",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#263238",
					stopOpacity: .2
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#263238",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint6_radial_6199_8810",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(10.1841 9.81818) scale(28.1273)",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .1
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
export default SvgAssetChromeIconOl;
